import { Icon as CIcon } from '@iconify/react';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props extends React.PropsWithChildren {
  icon?: React.ReactNode;
  variant?: 'success' | 'error' | 'warning';
  color?: string;
}

const HeadsUpMessage: React.FC<Props> = ({ variant = 'error', icon, children, ...otherProps }) => {
  const theme = useTheme();

  const variantToCol = {
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.main,
  };

  const color = otherProps.color || variantToCol[variant];

  const renderIcon = () => {
    if (icon) {
      return icon;
    }
    return <CIcon icon="charm:circle-warning" color={color} />;
  };

  return (
    <Box p={1} sx={{ color, display: 'flex', border: `1px solid ${color}`, borderRadius: 1, alignItems: 'center' }}>
      {renderIcon()}
      <Typography variant="caption" ml={1}>
        {children}
      </Typography>
    </Box>
  );
};

export default HeadsUpMessage;
